import { render, staticRenderFns } from "./activityChooseMallDialog.vue?vue&type=template&id=06e0f4e8"
import script from "./activityChooseMallDialog.vue?vue&type=script&lang=js"
export * from "./activityChooseMallDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports